export default "/assets/images/2022aug/milky_main.png"